import { Alert, getSize } from 'metrix-common3';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { asksTheSeller, sellerHasAgreed } from '../../../../constants/policy/sellerAgreement';

// Shown on every Profile tab while the seller of a policy converted from a certificate has not
// agreed to the application (PBI 24307), so the card is not charged nor the policy issued by
// mistake. Agreed means the declaration accepted and the date it was given, both.
// Set off from the page header, or the notice, above it.
const NoticeWrapper = styled.div`
    margin-top: ${getSize('md')}px;
`;

const SellerAgreementNotice = (props) => {
    const intl = useIntl();
    const info = props.policy?.secureMyOfferCustomInfo;

    if (!asksTheSeller(props.policy) || sellerHasAgreed(info)) {
        return null;
    }

    // Alert renders items as { code, value }, the shape of an Operation message.
    const items = [
        { code: 'body', value: intl.formatMessage({ id: 'Profile_SellerAgreementNotice.body' }) },
        ...(info?.sellerAgreeEmailSentOn
            ? [
                  {
                      code: 'sent',
                      value: intl.formatMessage(
                          { id: 'Profile_SellerAgreementNotice.sent' },
                          {
                              sentOn: intl.formatDate(info.sellerAgreeEmailSentOn, {
                                  dateStyle: 'medium',
                                  timeStyle: 'short',
                              }),
                          },
                      ),
                  },
              ]
            : []),
        { code: 'record', value: intl.formatMessage({ id: 'Profile_SellerAgreementNotice.record' }) },
    ];

    return (
        <NoticeWrapper>
            <Alert
                mode='warning'
                header={intl.formatMessage({ id: 'Profile_SellerAgreementNotice.header' })}
                items={items}
            />
        </NoticeWrapper>
    );
};

export default SellerAgreementNotice;
